import { render, staticRenderFns } from "./EmptyPrice.vue?vue&type=template&id=59b7ca92&"
import script from "./EmptyPrice.vue?vue&type=script&lang=js&"
export * from "./EmptyPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports